module.exports = __webpack_public_path__ + "../resources/img/ic_re_500error_glass_img.b16ff6d6.svg";